import { useState, useEffect } from 'react'
import {
  Button,
  Form,
  Grid,
  GridContainer,
  GridItem,
  Input,
  Modal,
  Spinner,
} from '@enterprise-ui/canvas-ui-react'
import { GET_REASONCODES, ReasonCodes } from '../../Cases/Common/Queries'
import {
  UpdateUpdateReasonCodeVar,
  UPDATE_REASONCODE,
} from '../common/AdminQueries'
import { useMutation } from '@apollo/client'

const reasonCodeMap = {
  active: false,
  supportingText: '',
}

export const EditReasonCodeForm = (props: any) => {
  const [columns, setColumns] = useState<any>(reasonCodeMap)

  useEffect(() => {
    setColumns({
      supportingText: props.editableRow?.supportDocList,
      active: props.editableRow?.active,
    })
  }, [props.editableRow, props.formVisible])

  const [updateReasonCode, { loading }] = useMutation<
    ReasonCodes,
    UpdateUpdateReasonCodeVar
  >(UPDATE_REASONCODE)

  const handleSave = async (row: ReasonCodes, columns: any) => {
    await updateReasonCode({
      variables: {
        id: row.reasonCodeId!,
        input: {
          reasonCodeText: row.reasonCodeText!,
          supportDocList: columns.supportingText,
          active: columns.active,
        },
      },
      refetchQueries: [
        {
          query: GET_REASONCODES,
        },
      ],
      awaitRefetchQueries: true,
    }).then(() => props.handleClose())
  }

  return (
    <Modal
      headingText="Edit Reason Code"
      onRefuse={() => {
        props.handleClose()
      }}
      isVisible={props.formVisible}
    >
      <Grid.Container justify={'center'} className="hc-pa-normal">
        <Grid.Item xs={11}>
          <Grid.Container>
            <Grid.Item xs={6}>
              <Input.Label>Reason Code</Input.Label>
              <Form.Field
                id="reasonCode"
                value={props?.editableRow?.reasonCodeId}
                disabled
              />
            </Grid.Item>

            <Grid.Item xs={6}>
              <Input.Label>Reason Code Text</Input.Label>
              <Form.Field
                id="reasonCodeText"
                value={props?.editableRow?.reasonCodeText}
                disabled
              />
            </Grid.Item>
            <Grid.Item xs={12}>
              <Form.Field
                id="supportingText"
                value={columns.supportingText}
                type="textarea"
                label="Supporting Document Text"
                onChange={(e: any) =>
                  setColumns({
                    ...columns,
                    supportingText: e.target.value,
                  })
                }
                size="dense"
              />
            </Grid.Item>
          </Grid.Container>
        </Grid.Item>
        <GridItem xs={11}>
          <GridContainer align="center">
            <GridItem xs={3}>
              <Form.Field
                id="ststus"
                type="toggle"
                label={'Active'}
                value={columns.active}
                onChange={(e: any) => {
                  setColumns({
                    ...columns,
                    active: !columns.active,
                  })
                }}
              ></Form.Field>
            </GridItem>
            <GridItem justify="flex-end" xs={9}>
              <GridContainer direction="row-reverse" spacing="dense">
                <GridItem>
                  <Button
                    type="primary"
                    onClick={() => {
                      handleSave(props.editableRow, columns)
                    }}
                    // disabled={loading}
                  >
                    Save
                  </Button>
                </GridItem>
                <GridItem>
                  <Button
                    onClick={() => {
                      props.handleClose()
                    }}
                  >
                    Cancel
                  </Button>
                </GridItem>

                {loading && (
                  <GridItem>
                    <Spinner></Spinner>
                  </GridItem>
                )}
              </GridContainer>
            </GridItem>
          </GridContainer>
        </GridItem>
      </Grid.Container>
    </Modal>
  )
}
